import { render, staticRenderFns } from "./mobile-product-description-banner.vue?vue&type=template&id=cf4344ca&scoped=true&"
import script from "./mobile-product-description-banner.vue?vue&type=script&lang=js&"
export * from "./mobile-product-description-banner.vue?vue&type=script&lang=js&"
import style0 from "./mobile-product-description-banner.vue?vue&type=style&index=0&id=cf4344ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4344ca",
  null
  
)

export default component.exports